import React, { useState, useEffect } from 'react';

// Isolated clock so the per-second tick doesn't re-render the whole dashboard.
export function HeaderClock() {
  const [now, setNow] = useState(new Date());
  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(id);
  }, []);
  return (
    <span style={{ color: '#fff', fontFamily: 'monospace', fontSize: 14 }}>
      {now.toLocaleTimeString()}
    </span>
  );
}
